import _property from 'lodash/property';
import _get from 'lodash/get';
import { compose } from 'recompose';

var id = _property('id');

var vin = _property('vin');

var make = _property('make');

var year = _property('year');

var model = _property('model');

var makeCode = _property('makeCode');

var source = _property('source');

var modelCodes = _property('modelCodes');

var stockId = _property('stockId');

var odometer = _property('odometer');

var vehicleID = _property('id');

var associatedCustomers = _property('associatedCustomers');

var VIN = _property('vin');
/* due to data inconsistency of vehicle */


var stockID = _property('stockID');
/* keeping key name as stockID instead of stockId, not sure if stockId is available in future */


var deleted = _property('deleted');

var marketScanVehicleId = _property('marketScanVehicleId');

var dealVehicleId = _property('dealVehicleId');

var primaryVehicle = _property('primaryVehicle');

var status = _property('status');

var vehicleType = _property('vehicleType');

var vehicleSubType = _property('vehicleSubType');

var grossVehicleWeightGrams = _property('grossVehicleWeightGrams');

var pricingDetails = _property('pricingDetails');

var licensePlateExpirationDate = _property('licensePlateExpirationDate');

var trimDetails = _property('trimDetails');

var temp = _property('temp');

var certified = _property('certified');

var bodyType = _property('bodyType');

var exteriorColor = _property('exteriorColor');

var entryTime = _property('entryTime');

var mileage = _property('mileage');

var soldTime = _property('vehicleSoldTime');

var msrp = compose(_property('msrp'), pricingDetails);
var glBalance = compose(_property('glBalance'), pricingDetails);
var retailPrice = compose(_property('retailPrice'), pricingDetails);
var holdBackAmount = compose(_property('holdBackAmount'), pricingDetails);
var flooringAmt = compose(_property('flooringAmt'), pricingDetails);

var vehicleCount = _property('vehicleCount');

var customVehicleUpdatedBy = _property('isCustomVehicleUpdatedBy');

var customVehicleUpdateAt = _property('isCustomVehicleUpdateDate');

var trim = _property('trim');

var engineDescriptionDisplay = _property('engineDescriptionDisplay');

var transmissionControlTypeDisplay = _property('transmissionControlTypeDisplay');

var driveType = _property('driveType');

var color = _property('color');

var licensePlate = _property('licensePlate');

var country = _property('country');

var createdTime = _property('createdTime');

var dealerId = _property('dealerId');

var inServiceDate = _property('inServiceDate');

var lastService = _property('lastService');

var lastServiceDate = _property('lastServiceDate');

var locationCode = _property('locationCode');

var RFID = _property('RFID');

var vinIgnoreCase = function vinIgnoreCase(data) {
  return _get(data, 'VIN') || _get(data, 'vin');
};

var displayModel = _property('displayModel');

var bodyClass = _property('bodyClass');

var uniqueStyleDisplayId = _property('uniqueStyleDisplayId');

var bestStyleName = _property('bestStyleName');

var postDate = _property('postDate');

export default {
  id: id,
  vin: vin,
  year: year,
  make: make,
  model: model,
  source: source,
  modelCodes: modelCodes,
  makeCode: makeCode,
  stockId: stockId,
  odometer: odometer,
  vehicleID: vehicleID,
  associatedCustomers: associatedCustomers,
  VIN: VIN,
  stockID: stockID,
  vehicleCount: vehicleCount,
  holdBackAmount: holdBackAmount,
  retailPrice: retailPrice,
  msrp: msrp,
  glBalance: glBalance,
  deleted: deleted,
  marketScanVehicleId: marketScanVehicleId,
  dealVehicleId: dealVehicleId,
  primaryVehicle: primaryVehicle,
  status: status,
  vehicleType: vehicleType,
  vehicleSubType: vehicleSubType,
  grossVehicleWeightGrams: grossVehicleWeightGrams,
  pricingDetails: pricingDetails,
  licensePlateExpirationDate: licensePlateExpirationDate,
  customVehicleUpdatedBy: customVehicleUpdatedBy,
  customVehicleUpdateAt: customVehicleUpdateAt,
  trimDetails: trimDetails,
  temp: temp,
  certified: certified,
  bodyType: bodyType,
  exteriorColor: exteriorColor,
  entryTime: entryTime,
  mileage: mileage,
  soldTime: soldTime,
  trim: trim,
  engineDescriptionDisplay: engineDescriptionDisplay,
  transmissionControlTypeDisplay: transmissionControlTypeDisplay,
  driveType: driveType,
  color: color,
  licensePlate: licensePlate,
  country: country,
  createdTime: createdTime,
  dealerId: dealerId,
  inServiceDate: inServiceDate,
  lastService: lastService,
  lastServiceDate: lastServiceDate,
  flooringAmt: flooringAmt,
  locationCode: locationCode,
  RFID: RFID,
  vinIgnoreCase: vinIgnoreCase,
  displayModel: displayModel,
  bodyClass: bodyClass,
  uniqueStyleDisplayId: uniqueStyleDisplayId,
  bestStyleName: bestStyleName,
  postDate: postDate
};